import { get } from 'helpers/api';
import { assign } from 'lodash';

import { getRequestReference } from 'helpers/axios';
import RansackQuery from 'helpers/ransack_query';
import debounceActionCreators from 'helpers/redux/debounce_action_creators';
import { CONVERSION_MAP } from 'helpers/unit_helpers';

const debouncedActionCreators = debounceActionCreators({ retrieveRecords }, 1000);

const keys = {
  page: 'page',
  pageSize: 'page_size',
  searchText: 'search_text',
  sort: 'sort',
  maxBuildingSize: 'q[max_building_size_or_min_building_size_lteq]',
  maxLeaseDate: 'q[max_lease_date_or_min_lease_date_lteq]',
  maxLotSize: 'q[max_lot_size_or_min_lot_size_lteq]',
  maxPrice: 'q[max_sale_price_or_min_sale_price_lteq]',
  maxUnits: 'q[max_number_of_units_or_min_number_of_units_lteq]',
  minBuildingSize: 'q[max_building_size_or_min_building_size_gteq]',
  minLeaseDate: 'q[max_lease_date_or_min_lease_date_gteq]',
  minLotSize: 'q[max_lot_size_or_min_lot_size_gteq]',
  minPrice: 'q[max_sale_price_or_min_sale_price_gteq]',
  minUnits: 'q[max_number_of_units_or_min_number_of_units_gteq]',
  cities: 'q[locations_city_in]',
  zip: 'q[locations_zip_cont]',
  state: 'q[locations_state_eq]',
  investmentTypes: 'q[investment_types_investment_type_id_in]',
  transactionTypes: 'q[transaction_type_in]',
  propertyTypes: 'q[requirement_asset_classes_asset_class_id_in]'
};

export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
function setSearchResults(requirementsSets, meta) {
  return { requirementsSets, meta, type: SET_SEARCH_RESULTS };
}

export const RETRIEVE_RECORDS_STARTED = 'RETRIEVE_RECORDS_STARTED';
function retrieveRecordsStarted(requestReference) {
  return { requestReference, type: RETRIEVE_RECORDS_STARTED };
}

export function retrieveRecords() {
  return (dispatch, getState) => {
    const { paths, search, query } = getState();

    if (search.requestReference) {
      search.requestReference.cancel();
    }

    const requestReference = getRequestReference();
    dispatch(retrieveRecordsStarted(requestReference));

    const ransackQuery = new RansackQuery(retrieveFilterOptions(query), keys).toRansack();

    get(paths.requirementsSetsPath, {
      cancelToken: requestReference.token,
      params: ransackQuery
    }).then((results) => {
      dispatch(setSearchResults(results.requirementSets, results.meta));
    }).catch(() => {});
  };
}

export function delayRetrieveRecords() {
  return dispatch => debouncedActionCreators.retrieveRecords(dispatch);
}

function retrieveFilterOptions(query) {
  const { addressFilter, propertyFilter, ...remainderQuery } = { ...query } ;
  const {
    buildingSizeUnits,
    minBuildingSize,
    maxBuildingSize,
    lotSizeUnits,
    minLotSize,
    maxLotSize,
    ...filterOptions
  } = { ...addressFilter, ...propertyFilter, ...remainderQuery };

  if (buildingSizeUnits == 'acres') {
    assign(filterOptions, {
      minBuildingSize: minBuildingSize ? minBuildingSize * CONVERSION_MAP[buildingSizeUnits] : null,
      maxBuildingSize: maxBuildingSize ? maxBuildingSize * CONVERSION_MAP[buildingSizeUnits] : null
    });
  } else {
    assign(filterOptions, { minBuildingSize, maxBuildingSize });
  }

  if (lotSizeUnits == 'acres') {
    assign(filterOptions, {
      minLotSize: minLotSize ? minLotSize * CONVERSION_MAP[lotSizeUnits] : null,
      maxLotSize: maxLotSize ? maxLotSize * CONVERSION_MAP[lotSizeUnits] : null
    });
  } else {
    assign(filterOptions, { minLotSize, maxLotSize });
  }

  return filterOptions;
}

export function downloadRequirementsSetsAsCsv() {
  return (_, getState) => {
    const { paths, query } = getState();
    const params = new RansackQuery(query, keys).toRansack();
    window.location.assign(`${paths.requirementsSetsToCsv}?${new URLSearchParams(params)}`);
  };
}
